import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { history } from '../store'
import { push } from 'react-router-redux'
import AppBaqueiraHeader from '../containers/AppBaqueiraHeader'
import { withNamespaces } from "react-i18next"
import { fetchDisponibility, fetchAvailability } from '../actions/qrsbaqueira'
import StepBarBaqueira from '../components/StepBarBaqueira'
import {
  QuantitySlider,
  QuantityStepper,
  QuantityButtonGrid,
  QuantityChipGroup,
  QuantityCheckboxBar,
  QuantitySegmented,
} from '../components/QuantityPickers';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import enGB from "date-fns/locale/en-GB"; // Import the locale
import { fetchCalendarByOperator } from '../actions/calendars';
import { format } from 'date-fns';
import { fromZonedTime } from 'date-fns-tz';

registerLocale("en-GB", enGB); // Register the locale

const TZ = 'Europe/Madrid';

function madrid1500ToUtc(dateObj) {
  // Use only the calendar day, ignore the device timezone/time
  const ymd = format(dateObj, 'yyyy-MM-dd'); // e.g. "2025-11-29"
  return fromZonedTime(`${ymd} 15:00:00`, TZ); // -> Date; .toISOString() is UTC
}

function formatYMD(date) {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

function applyBusinessRules(totalAmount, daysSelected, businessRules) {

  // Filter only active "MaxDayDiscount" rules
  const activeRules = businessRules.filter(
    (rule) => rule.Active && rule.Type === "MaxDayDiscount"
  );

  if (!activeRules.length) return { total: totalAmount, applied: null };

  // Sort rules by MaxDays descending (so we check the most restrictive first)
  activeRules.sort((a, b) => b.MaxDays - a.MaxDays);

  // Find the first rule that matches daysSelected
  const matchingRule = activeRules.find((rule) => daysSelected >= rule.MaxDays);

  if (matchingRule) {
    const discount = matchingRule.DiscountPercentage;
    const discountedAmount = totalAmount * (1 - discount / 100);
    return { total: discountedAmount, applied: matchingRule };
  }

  return { total: totalAmount, applied: null };
}

class LockerSelectorBaqueiraView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      step: 1,
      lockers: null,
      prices: null,
      selectedLockerType: null,
      selectedQuantity: 1,
      startDate: null,
      endDate: null,
      selectedInfo: null,  // Stores selected information for display
      qrType: "pay",
      errorMessage: false,
      isDurationExceeded: false,
      priceCalendar: {},
      calendarMonth: new Date(),
      limitDays: 13, // Maximum rental duration in days
      selectedPrices: [],
      totalAmount: 0,
      useUnifiedUI: true,              // ← turn unified form ON
      isTypeModalOpen: false,
      isQtyModalOpen: false,
      isDatesModalOpen: false,
      isLoading: false,
      activePanel: 'type',      // 'type' | 'qty' | 'dates' | null
      businessRules: [],
      appliedRule: null
    };

    this.handleQuantityChange = this.handleQuantityChange.bind(this);
    this.handleStartDateChange = this.handleStartDateChange.bind(this);
    this.handleEndDateChange = this.handleEndDateChange.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.handleContinue = this.handleContinue.bind(this);
  }

  openModal = (key) => this.setState({ [key]: true });
  closeModal = (key) => this.setState({ [key]: false });

  openPanel = (panel) => this.setState({ activePanel: panel });
  closePanel = () => this.setState({ activePanel: null });

  componentDidMount() {
    const { zoneSelected, qr } = this.props.location.state;
    const qrtoken = qr.toString() + zoneSelected.toString();

    this.props.fetchAvailability(qrtoken)
      .then((answer) => {
        const answerLockers = answer.response.answerLockers;
        this.setState({
          lockers: answerLockers.Disponibility,
          prices: answerLockers.Prices,
          qrType: answerLockers.qrType
        });
      })
      .catch((error) => {
        console.error(error);
      });
  }

  selectLockerType(lockerType) {
    const lockerPrice = this.getLockerPrice(lockerType);
    const { zoneSelected, descriptionZone } = this.props.location.state;

    this.setState({
      selectedLockerType: lockerType,
      selectedInfo: { lockerType, lockerPrice, zoneSelected, descriptionZone },
      step: 2,
      priceCalendar: {},
      ...(this.state.useUnifiedUI ? { isTypeModalOpen: false } : {})
    });

    this.props.fetchCalendarByOperator("66ed5789f181bef9df55042c", lockerType, zoneSelected)
      .then((response) => {
        const calendarArray = response?.response?.PriceCalendar || [];
        const rulesFromOperator = (response?.response?.BusinessRules || [])
          .filter(r => r && r.Active); // removes null and inactive

        // 🔥 Flatten the price calendar into a simple { "YYYY-MM-DD": price } object
        const flatPriceMap = {};

        calendarArray.forEach(entry => {
          const d = new Date(entry.date); // UTC from DB
          const isoDate = d.toLocaleDateString('en-CA', { timeZone: 'Europe/Madrid' });

          const matchedPrice = entry.prices.find(
            p => p.zone === zoneSelected && p.type === lockerType
          );

          if (matchedPrice) {
            flatPriceMap[isoDate] = matchedPrice.price;
          }
        });

        this.setState({
          priceCalendar: flatPriceMap,
          businessRules: rulesFromOperator
        });
      })
      .catch((error) => {
        console.error("Error fetching calendar data:", error);
      });
  }

  renderMonthGrid(monthDate, isFirstMonth) {
    const { priceCalendar, startDate, endDate, calendarMonth, selectedQuantity } = this.state;
    const { t, i18n } = this.props

    const year = monthDate.getFullYear();
    const month = monthDate.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const daysInMonth = lastDay.getDate();
    const blanks = Array(firstDay.getDay() === 0 ? 6 : firstDay.getDay() - 1).fill(null); // Monday start

    const weekDays = [t('Lun'), t('Mar'), t('Mie'), t('Jue'), t('Vie'), t('Sab'), t('Dom')];
    const title = firstDay.toLocaleString('default', { month: 'long', year: 'numeric' });

    const days = [];

    for (let d = 1; d <= daysInMonth; d++) {
      const date = new Date(year, month, d);
      const iso = date.toLocaleDateString("en-CA", { timeZone: "Europe/Madrid" });
      const price = priceCalendar[iso];

      const isStart = startDate && date.toDateString() === startDate.toDateString();
      const isEnd = endDate && date.toDateString() === endDate.toDateString();
      const inRange = startDate && endDate && date > startDate && date < endDate;
      const isPast = this.isBeforeToday(date);
      const isLessThanStart = this.isBeforeStart(date);

      let className = "calendar-cell";
      if (isStart) className += " selected start";
      else if (isEnd) className += " selected end";
      else if (inRange) className += " in-range";
      if (isPast || !price) className += " disable";

      days.push(
        <div
          key={iso}
          className={className}
          onClick={() => {
            if (!isPast && price) {
              this.handleCalendarDateClick(new Date(date));
            }
          }}
          title={price ? `Precio: ${(price * selectedQuantity).toFixed(2)} €` : 'Sin precio'}
        >
          <div className="day">{d}</div>
          <div className="price">{(price && !isPast) ? `${(price * selectedQuantity).toFixed(2)} €` : '-'}</div>
        </div>
      );
    }

    return (
      <div className="month-grid">
        <div className="calendar-header">
          <button
            className="nav-btn"
            disabled={this.isCurrentMonthOrBefore(calendarMonth)}
            onClick={() => {
              if (!this.isCurrentMonthOrBefore(calendarMonth)) {
                this.setState({
                  calendarMonth: new Date(calendarMonth.setMonth(calendarMonth.getMonth() - 1))
                });
              }
            }}
          >
            &lt;
          </button>
          <h6 className="month-title">
            {title.charAt(0).toUpperCase() + title.slice(1)}
          </h6>
          <button
            className="nav-btn"
            onClick={() =>
              this.setState({ calendarMonth: new Date(calendarMonth.setMonth(calendarMonth.getMonth() + 1)) })
            }
          >
            &gt;
          </button>
        </div>

        <div className="calendar-grid">
          {weekDays.map(day => (
            <div key={day} className="calendar-cell weekday-header">
              {day}
            </div>
          ))}
          {blanks.map((_, i) => <div key={`blank-${i}`} className="calendar-cell empty" />)}
          {days}
        </div>
      </div>
    );
  }

  renderMonthGridPC(monthDate, isFirstMonth) {
    const { priceCalendar, startDate, endDate, calendarMonth, selectedQuantity } = this.state;
    const { t, i18n } = this.props

    const year = monthDate.getFullYear();
    const month = monthDate.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const daysInMonth = lastDay.getDate();
    const blanks = Array(firstDay.getDay() === 0 ? 6 : firstDay.getDay() - 1).fill(null); // Monday start

    const weekDays = [t('Lun'), t('Mar'), t('Mie'), t('Jue'), t('Vie'), t('Sab'), t('Dom')];
    const title = firstDay.toLocaleString('default', { month: 'long', year: 'numeric' });

    const days = [];

    for (let d = 1; d <= daysInMonth; d++) {
      const date = new Date(year, month, d);
      const iso = date.toLocaleDateString('en-CA', { timeZone: 'Europe/Madrid' });
      const price = priceCalendar[iso];

      const isStart = startDate && date.toDateString() === startDate.toDateString();
      const isEnd = endDate && date.toDateString() === endDate.toDateString();
      const inRange = startDate && endDate && date > startDate && date < endDate;
      const isPast = this.isBeforeToday(date);

      let className = "calendar-cell";
      if (isStart) className += " selected start";
      else if (isEnd) className += " selected end";
      else if (inRange) className += " in-range";
      if (isPast || !price) className += " disable";

      days.push(
        <div
          key={iso}
          className={className}
          onClick={() => {
            if (!isPast && price) {
              this.handleCalendarDateClick(new Date(date));
            }
          }}
          title={price ? `Precio: ${(price * selectedQuantity)} €` : 'Sin precio'}
        >
          <div className="day">{d}</div>
          <div className="price">{price ? `${(price * selectedQuantity)} €` : '-'}</div>
        </div>
      );
    }

    return (
      <div className="month-grid">
        <div className="calendar-header">
          {isFirstMonth && (
            <button
              className="nav-btn"
              disabled={this.isCurrentMonthOrBefore(calendarMonth)}
              onClick={() => {
                if (!this.isCurrentMonthOrBefore(calendarMonth)) {
                  this.setState({
                    calendarMonth: new Date(calendarMonth.setMonth(calendarMonth.getMonth() - 1))
                  });
                }
              }}
            >
              &lt;
            </button>
          )}
          <h6 className="month-title">
            {title.charAt(0).toUpperCase() + title.slice(1)}
          </h6>
          {!isFirstMonth && (
            <button
              className="nav-btn"
              onClick={() =>
                this.setState({ calendarMonth: new Date(calendarMonth.setMonth(calendarMonth.getMonth() + 1)) })
              }
            >
              &gt;
            </button>
          )}
        </div>

        <div className="calendar-grid">
          {weekDays.map(day => (
            <div key={day} className="calendar-cell weekday-header">
              {day}
            </div>
          ))}
          {blanks.map((_, i) => <div key={`blank-${i}`} className="calendar-cell empty" />)}
          {days}
        </div>
      </div>
    );
  }

  renderPriceCalendarPC() {
    const { calendarMonth } = this.state;

    const nextMonth = new Date(calendarMonth);
    nextMonth.setMonth(calendarMonth.getMonth() + 1);

    return (
      <div className="dual-calendar-container">
        {this.renderMonthGridPC(calendarMonth, true)}
        {this.renderMonthGridPC(nextMonth, false)}
      </div>
    );
  }

  renderPriceCalendar() {
    const { calendarMonth } = this.state;

    const nextMonth = new Date(calendarMonth);
    nextMonth.setMonth(calendarMonth.getMonth() + 1);

    return (
      <div className="dual-calendar-container">
        {this.renderMonthGrid(calendarMonth, true)}
      </div>
    );
  }

  handleCalendarDateClick = (clickedDate) => {
    const { startDate, endDate, priceCalendar, selectedQuantity } = this.state;

    if (startDate && clickedDate.toDateString() === startDate.toDateString()) {
      this.setState({
        startDate: null,
        endDate: null,
        selectedPrices: [],
        totalAmount: 0,
        isDurationExceeded: false,
      });
      return;
    } else if (!startDate) {
      const iso = clickedDate.toLocaleDateString("en-CA", { timeZone: "Europe/Madrid" });
      const base = priceCalendar[iso] || 0;
      const dayPrice = base * (selectedQuantity || 1);

      this.setState({
        startDate: clickedDate,
        endDate: clickedDate,                 // same day
        isDurationExceeded: false,
        selectedPrices: base ? [{ date: new Date(clickedDate), price: dayPrice }] : [],
        totalAmount: base ? dayPrice : 0
      });
      return;
    } else if (clickedDate < startDate) {
      // Reset start if clicked before
      this.setState({ startDate: clickedDate, endDate: null, isDurationExceeded: false, selectedPrices: [], totalAmount: 0 });
    } else {
      const diff = Math.ceil((clickedDate - startDate) / (1000 * 60 * 60 * 24));
      const tooLong = diff > this.state.limitDays;

      if (!tooLong) {
        const selectedPrices = [];
        let totalAmount = 0;

        for (let d = new Date(startDate); d <= clickedDate; d.setDate(d.getDate() + 1)) {
          const iso = d.toLocaleDateString("en-CA", { timeZone: "Europe/Madrid" });
          const price = priceCalendar[iso];
          if (price) {
            const dayPrice = price * selectedQuantity;
            selectedPrices.push({ date: new Date(d), price: dayPrice });
            totalAmount += dayPrice;
          }
        }

        // ✅ Apply business rules discount here
        const daysSelected = selectedPrices.length;
        const { total, applied } = applyBusinessRules(totalAmount, daysSelected, this.state.businessRules);

        this.setState({
          endDate: clickedDate,
          isDurationExceeded: tooLong,
          selectedPrices,
          totalAmount: total,
          appliedRule: applied
        });
      } else {
        this.setState({ endDate: clickedDate, isDurationExceeded: true });
      }
    }
  };

  handleQuantityChange(event) {
    this.setState({ selectedQuantity: event.target.value, startDate: null, endDate: null, selectedPrices: [], totalAmount: 0, isDurationExceeded: false });
  }

  handleStartDateChange(date) {
    const { endDate } = this.state;
    const localDate = new Date(date.setHours(15, 0, 0, 0)); // Set to the start of the day in local time

    if (endDate) {
      const differenceInDays = Math.ceil((endDate - localDate) / (1000 * 60 * 60 * 24));
      this.setState({
        startDate: localDate,
        isDurationExceeded: differenceInDays >= this.state.limitDays, // Show message if duration exceeds 14 days
      });
    } else {
      this.setState({ startDate: localDate });
    }
  }

  handleEndDateChange(date) {
    const { startDate } = this.state;
    const localDate = new Date(date.setHours(15, 0, 0, 0)); // Set to the start of the day in local time

    if (startDate) {
      const differenceInDays = Math.ceil((localDate - startDate) / (1000 * 60 * 60 * 24));
      this.setState({
        endDate: localDate,
        isDurationExceeded: differenceInDays >= this.state.limitDays, // Show message if duration exceeds 14 days
      });
    } else {
      this.setState({ endDate: localDate });
    }
  }

  isAfterCutoffTime() {
    const nowInSpain = new Date().toLocaleString("en-US", { timeZone: "Europe/Madrid" });
    const currentHourInSpain = new Date(nowInSpain).getHours();
    return currentHourInSpain >= 18;
  }

  handleContinue() {
    if (this.state.isLoading) return;
    this.setState({ isLoading: true, errorMessage: false });
    const { selectedLockerType, selectedQuantity, startDate, endDate, qrType } = this.state;
    const { zoneSelected, descriptionZone, qr } = this.props.location.state;

    const localStartDate = madrid1500ToUtc(this.state.startDate);
    const localEndDate = madrid1500ToUtc(this.state.endDate);

    console.log("Start: " + localStartDate + " End" + localEndDate);

    const lockerQty = selectedQuantity == null ? 1 : Number(selectedQuantity);

    const bookingData = {
      Zone: zoneSelected,
      LockerType: selectedLockerType,
      LockerQty: lockerQty,
      RentalStartDate: localStartDate,
      RentalFinishDate: localEndDate,
      PaymentMethod: 'TPV'
    };

    this.props.fetchDisponibility(bookingData)
      .then((answer) => {
        if (answer.response.LockersDisponibility === true) {

          const lockerAssigned = answer.response.LockersAssigned
          const lockerAmount = answer.response.LockersAmount
          const prerentCode = answer.response.PrerentCode
          const prerentTime = answer.response.PrerentTime
          const totalDays = answer.response.TotalDays
          const timeStamp = answer.response.TimeStamp

          this.props.push('/PhoneBaqueiraView', {
            zoneSelected: zoneSelected,
            descriptionZone: descriptionZone,
            selectedLocker: selectedLockerType,
            lockerPrice: lockerAmount,
            lockerAssigned: lockerAssigned,
            prerentCode: prerentCode,
            prerentTime: prerentTime,
            totalDays: totalDays,
            startDate: startDate,
            endDate: endDate,
            qrType: qrType,
            qr: qr,
            timeStamp: timeStamp,
            selectedQuantity: selectedQuantity
          })
        } else {
          this.setState({ errorMessage: true, isLoading: false });
        }
      })
      .catch((error) => {
        console.error(error);
        this.setState({ isLoading: false });
      });
  }

  getLockerType(type) {
    const { t, i18n } = this.props

    switch (type) {
      case "BNS":
        return 'STANDARD'
      case "CNS":
        return 'STANDARD CARGA'
      case "BWS":
        return 'STANDARD XL'
      case "CWS":
        return 'STANDARD CARGA XL'
      case "BNM":
        return 'MEDIUM'
      case "CNM":
        return 'MEDIUM CARGA'
      case "BWM":
        return 'MEDIUM XL'
      case "CWM":
        return 'MEDIUM CARGA XL'
      case "BNL":
        return 'LARGE'
      case "CNL":
        return 'LARGE CARGA'
      case "BWL":
        return 'LARGE XL'
      case "CWL":
        return 'LARGE CARGA XL'
      case "BNXL":
        return 'LARGE'
      case "CNXL":
        return 'LARGE CARGA'
      case "BWXL":
        return 'LARGE XL'
      case "CWXL":
        return 'LARGE CARGA XL'
      case "BN2XL":
        return 'LARGE'
      case "CN2XL":
        return 'LARGE CARGA'
      case "BW2XL":
        return 'LARGE XL'
      case "CW2XL":
        return 'LARGE CARGA XL'
      case "BN3XL":
        return t('2 Equipos de esquí')
      case "CN3XL":
        return t('3 Equipos de esquí')
      case "BW3XL":
        return t('4 Equipos de esquí')
      case "CW3XL":
        return t('SKI CARGA XL')
      default:
        return 'STANDARD'
    }
  }

  getLockerPicture(type) {
    return `/images/locker_baqueira_${type}.png`
  }

  getLockerPrice(type) {
    const { prices } = this.state;
    const lockerPriceObj = prices.find((price) => price.item === `LOCKER${type}`);
    return lockerPriceObj ? Number(lockerPriceObj.price).toFixed(2) : "0.00";
  }

  renderLockers() {
    const { t, i18n } = this.props
    const { lockers, prices } = this.state;
    const { zoneSelected, descriptionZone } = this.props.location.state;
    const lockerDivs = []

    if (!lockers || !prices) {
      return (<div className="spinner-baqueira"><img src="/images/logo_baqueira.png" alt="Logo" /></div>)
    } else {
      Object.keys(lockers).forEach((lockerKey) => {
        const locker = lockers[lockerKey];

        lockerDivs.push(
          <div className="col-xs-12 titleh5" key={lockerKey}>
            <div className="lockButton" onClick={() => this.selectLockerType(lockerKey)}>
              <div className="row">
                <div className="colLockersBaqueira">
                  <img src={this.getLockerPicture(lockerKey)} alt={"locker_baqueira_" + lockerKey} className="lockerSmallImageBaqueira" />
                </div>
                <div className="col">
                  <h6 className="titleLockers">{t('Taquilla')}</h6>
                  <h5 className="col lockerTextDescription">{this.getLockerType(lockerKey)}</h5>
                </div>
              </div>
            </div>
          </div>
        );
      });

      if (lockerDivs.length === 0) {
        return (
          <div className="col-xs-12 titleh5">
            <div className="lockSoldOutButton" onClick={(e) => this.goBack(e)}>
              <h5>{t('TAQUILLAS AGOTADAS')}</h5>
              <h6>{t('Haz click aquí para volver a selección de zonas')}</h6>
              <div className="lockSoldOutImgContainer">
                <img className="lockSoldOutImg" src="/images/locker_BNS.png" alt="Locker" />
                <img className="lockSoldOutCross" src="/images/cross.png" alt="Cross" />
              </div>
            </div>
          </div>
        )
      }

      return (<div>{lockerDivs}</div>)
    }
  }

  renderLockersPc() {
    const { t, i18n } = this.props
    const { lockers, prices } = this.state;
    const { zoneSelected, descriptionZone } = this.props.location.state;
    const lockerDivs = []

    if (!lockers || !prices) {
      return (<div className="spinner-baqueira"><img src="/images/logo_baqueira.png" alt="Logo" /></div>)
    } else {
      Object.keys(lockers).forEach((lockerKey) => {
        const locker = lockers[lockerKey];

        lockerDivs.push(
          <div className="lockButton" onClick={(e) => { this.selectLockerType(lockerKey); this.openPanel("qty"); }}>
            <div className="col text-vw-dark-baqueira p-3">
              <h6>{t('Taquilla')}</h6>
              <h5>{this.getLockerType(lockerKey)}</h5>
            </div>
            <img src={this.getLockerPicture(lockerKey)} alt={"locker_" + lockerKey} className="lockerSmallImageBaqueira" />
          </div>
        );
      });

      if (lockerDivs.length == 0) {
        return (
          <div>
            <div className="col-xs-12 titleh5">
              <div className="lockSoldOutButton" onClick={(e) => this.goBack(e)}>
                <h5>{t('TAQUILLAS AGOTADAS')}</h5>
                <h6>{t('Haz click aquí para volver a selección de zonas')}</h6>
                <div className="lockSoldOutImgContainer">
                  <img className="lockSoldOutImg" src="/images/locker_BNS.png" alt="Locker" />
                  <img className="lockSoldOutCross" src="/images/cross.png" alt="Cross" />
                </div>
              </div>
            </div>
          </div>
        )
      }

      return (
        <div style={{ width: '100%', overflowX: 'auto', overflowY: 'hidden' }}>
          <div className="row justify-content-center" style={{ display: 'flex', flexDirection: 'row', gap: '1rem', padding: '1rem 0', minWidth: 'max-content' }}>
            {lockerDivs}
          </div>
        </div>
      )
    }
  }

  handleBack(step) {

    this.setState({ errorMessage: false });

    switch (step) {
      case 1: this.setState({ selectedLockerType: null, selectedInfo: null, selectedQuantity: null }, () => {
        this.setState({ step: 1 });
      });
        break;

      case 2: this.setState({ selectedQuantity: null, startDate: null, endDate: null }, () => {
        this.setState({ step: 2 });
      });
        break;

      case 3: this.setState({ startDate: null, endDate: null }, () => {
        this.setState({ step: 3 });
      });
        break;

    }
  }

  handleForward(step) {
    switch (step) {
      case 1:
        if (this.state.selectedQuantity) this.setState({ step: 3 });
        break;

      case 2:
        if (this.state.startDate && !this.state.isDurationExceeded) {
          const { startDate, endDate, priceCalendar, selectedQuantity } = this.state;
          const finalEnd = endDate || startDate;

          // If endDate was missing, compute 1-day pricing now
          let selectedPrices = this.state.selectedPrices;
          let totalAmount = this.state.totalAmount;

          if (!endDate) {
            const iso = new Date(startDate).toLocaleDateString("en-CA", { timeZone: "Europe/Madrid" });
            const basePrice = priceCalendar[iso] || 0;
            const dayPrice = basePrice * (selectedQuantity || 1);
            selectedPrices = basePrice ? [{ date: new Date(startDate), price: dayPrice }] : [];
            totalAmount = selectedPrices.reduce((sum, p) => sum + p.price, 0);
          }

          this.setState({
            endDate: finalEnd,
            selectedPrices,
            totalAmount,
            step: 4
          });
        }
        break;
    }
  }

  isBeforeToday(date) {
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Remove time
    return date < today;
  }

  isBeforeStart(date) {
    const { startDate } = this.state;

    const today = new Date(startDate);
    today.setHours(0, 0, 0, 0); // Remove time
    return date < today;
  }

  isCurrentMonthOrBefore(date) {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();

    return date.getFullYear() <= year && date.getMonth() <= month;
  }

  renderUnifiedForm(mode = 'mobile') {
    const { t } = this.props;
    const { zoneSelected, descriptionZone } = this.props.location.state;
    const { selectedLockerType, selectedQuantity, startDate, endDate, isDurationExceeded, totalAmount, appliedRule } = this.state;

    const qty = selectedQuantity == null ? 1 : Number(selectedQuantity);
    const canContinue = (selectedLockerType && selectedQuantity && startDate && !isDurationExceeded);

    return (
      <div className="unified-form">
        {/* ZONE (read-only) */}
        <div className="uf-row">
          <label className="uf-label">{t('Zona')}</label>
          <button type="button" className="uf-btn" disabled>
            {zoneSelected} - {descriptionZone}
          </button>
        </div>

        {/* TYPE */}
        <div className="uf-row">
          <label className="uf-label">{t('Tipo')}</label>
          <button
            type="button"
            className="uf-btn"
            onClick={() => this.openModal('isTypeModalOpen')}
          >
            {selectedLockerType ? this.getLockerType(selectedLockerType) : t('Selecciona...')}
          </button>
        </div>

        {/* QUANTITY */}
        <div className="uf-row">
          <label className="uf-label">{t('Cantidad')}</label>
          <button
            type="button"
            className="uf-btn"
            onClick={() => this.openModal('isQtyModalOpen')}
            disabled={!selectedLockerType}
          >
            {qty} {qty === 1 ? ' ' + t('taquilla') : ' ' + t('taquillas')}
          </button>
        </div>

        {/* DATES */}
        <div className="uf-row">
          <div className='d-flex'>
            <div className='col'>
              <label className="uf-label">{t('Inicio')}</label>
              <button
                type="button"
                className="uf-btn"
                onClick={() => this.openModal('isDatesModalOpen')}
                disabled={!selectedLockerType}
              >
                {startDate
                  ? `${startDate.toLocaleDateString()}`
                  : t('DD/MM/YYYY')}
              </button>
            </div>
            <div className='col'>
              <label className="uf-label">{t('Fin')}</label>
              <button
                type="button"
                className="uf-btn"
                onClick={() => this.openModal('isDatesModalOpen')}
                disabled={!selectedLockerType}
              >
                {endDate
                  ? `${endDate.toLocaleDateString()}`
                  : t('DD/MM/YYYY')}
              </button>
            </div>
          </div>
        </div>

        {/* TOTAL 
        <div className="uf-row">
          <label className="uf-label">{t('Importe')}</label>
          <button
            type="button"
            className="uf-btn"
          >
            {totalAmount.toFixed(2)} €
          </button>
        </div>*/}

        {/* ERROR MESSAGE */}
        {this.state.errorMessage &&
          <div className="text-danger text-center">{t("LO SENTIMOS PERO ESTAS FECHAS NO ESTÁN DISPONIBLES, PRUEBA OTRAS U OTRO TIPO DE TAQUILLAS.")}</div>
        }

        {/*DISCOUNT*/}
        {appliedRule && (
          <span className='text-center'>
            {t("Descuento aplicado: {{discount}}% (desde los {{days}} días)", {
              discount: appliedRule.DiscountPercentage,
              days: appliedRule.MaxDays
            })}
          </span>
        )}

        {/* CONTINUE */}
        <div className="uf-actions">
          <button
            className={`lockerContinueButtonBaqueira ${!canContinue || this.state.isLoading ? 'disabled-baqueira' : ''}`}
            disabled={!canContinue || this.state.isLoading}
            onClick={() => this.handleContinue()}
          >
            {this.state.isLoading ? (
              <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
            ) : (
              <>{t("Continuar")}{t(" por ")}{totalAmount.toFixed(2)}{' €'}</>
            )}
          </button>
        </div>

        {this.renderUnifiedModals()}
      </div>
    );
  }

  renderUnifiedModals() {
    const { t } = this.props;
    const { isTypeModalOpen, isQtyModalOpen, isDatesModalOpen, selectedQuantity, startDate, endDate, isDurationExceeded, appliedRule } = this.state;
    const qty = selectedQuantity == null ? 1 : Number(selectedQuantity);

    return (
      <>
        {/* TYPE MODAL */}
        {isTypeModalOpen && (
          <div className="uf-modal-overlay" onClick={() => this.closeModal('isTypeModalOpen')}>
            <div className="uf-modal" onClick={(e) => e.stopPropagation()}>
              <div className="uf-modal-header">
                <h5 className="text-vw-dark-baqueira">{t('Selecciona el tipo de taquilla')}</h5>
              </div>
              <div className="uf-modal-body">
                {/* Reuse your locker list UI */}
                {this.renderLockers()}
              </div>
              <div className="uf-modal-footer">

              </div>
            </div>
          </div>
        )}

        {/* QTY MODAL */}
        {isQtyModalOpen && (
          <div className="uf-modal-overlay" onClick={() => this.closeModal('isQtyModalOpen')}>
            <div className="uf-modal" onClick={(e) => e.stopPropagation()}>
              <div className="uf-modal-header">
                <h5 className="text-vw-dark-baqueira">{t('Selecciona la cantidad')}</h5>
              </div>
              <div className="uf-modal-body">
                <QuantityStepper
                  min={1}
                  max={10}
                  value={qty}
                  label={''}
                  onChange={(v) => this.setState({ selectedQuantity: v, startDate: null, endDate: null, selectedPrices: [], totalAmount: 0, isDurationExceeded: false, appliedRule: null })}
                />
              </div>
              <div className="uf-modal-footer">
                <button className="lockerContinueButtonBaqueira" onClick={() => this.closeModal('isQtyModalOpen')}>
                  {t('Confirmar')}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* DATES MODAL */}
        {isDatesModalOpen && (
          <div className="uf-modal-overlay" onClick={() => this.closeModal('isDatesModalOpen')}>
            <div className="uf-modal text-center" onClick={(e) => e.stopPropagation()}>
              <div className="uf-modal-header">
                <h5 className="text-vw-dark-baqueira">{t('Selecciona las fechas')}</h5>
              </div>
              <div className="uf-modal-body">
                {/* Reuse your price calendar (mobile version here) */}
                {this.renderPriceCalendar()}
                {isDurationExceeded && (
                  <div className="text-center text-danger mt-2">
                    {t(`El alquiler online está limitado a 14 días consecutivos, para realizar reservas de larga duración diríjase al staff de Baqueira Store o solicítelo via email a skiservice@baqueira.es`)}
                  </div>
                )}
              </div>
              <div className="uf-modal-footer">
                <div className='row'>
                  <div className='col' style={{ display: "flex", flexDirection: "column" }}>
                    <label className="uf-label">{t('Inicio')}</label>
                    <span>
                      {startDate
                        ? `${startDate.toLocaleDateString()}`
                        : t('DD/MM/YYYY')}
                    </span>
                  </div>
                  <vr class="bg-vw-light"></vr>
                  <div className='col' style={{ display: "flex", flexDirection: "column" }}>
                    <label className="uf-label">{t('Fin')}</label>
                    <span>
                      {endDate
                        ? `${endDate.toLocaleDateString()}`
                        : t('DD/MM/YYYY')}
                    </span>
                  </div>
                </div>
                <hr></hr>
                {appliedRule && (
                  <span>
                    {t("Descuento aplicado: {{discount}}% (desde los {{days}} días)", {
                      discount: appliedRule.DiscountPercentage,
                      days: appliedRule.MaxDays
                    })}
                  </span>
                )}
                <br></br>
                <button
                  className="lockerContinueButtonBaqueira"
                  disabled={!startDate || isDurationExceeded}
                  onClick={() => this.closeModal('isDatesModalOpen')}
                >
                  {t('Confirmar')}
                </button>
              </div>

            </div>
          </div>
        )}
      </>
    );
  }

  renderUnifiedFormPc() {
    const { t } = this.props;
    const { zoneSelected, descriptionZone } = this.props.location.state;
    const {
      selectedLockerType,
      selectedQuantity,
      startDate,
      endDate,
      isDurationExceeded,
      totalAmount,
      appliedRule
    } = this.state;

    const qty = selectedQuantity == null ? 1 : Number(selectedQuantity);
    const canContinue =
      selectedLockerType && selectedQuantity && startDate && !isDurationExceeded;

    return (
      <>
        {/* FORM ROW */}
        <div className="unified-form">

          <div className="uf-row" style={{ display: "flex", gap: "12px" }}>
            {/* ZONE */}
            <div style={{ flex: 1 }}>
              <label className="uf-label">{t("Zona")}</label>
              <button type="button" className="uf-btn" disabled>
                {zoneSelected} - {descriptionZone}
              </button>
            </div>

            <vr class="bg-vw-light"></vr>

            {/* TYPE */}
            <div style={{ flex: 1 }}>
              <label className="uf-label">{t("Tipo")}</label>
              <button
                type="button"
                className="uf-btn"
                onClick={() => this.openPanel("type")}
              >
                {selectedLockerType
                  ? this.getLockerType(selectedLockerType)
                  : t("Selecciona...")}
              </button>
            </div>

            <vr class="bg-vw-light"></vr>

            {/* QUANTITY */}
            <div style={{ flex: 1 }}>
              <label className="uf-label">{t("Cantidad")}</label>
              <button
                type="button"
                className="uf-btn"
                onClick={() => this.openPanel("qty")}
                disabled={!selectedLockerType}
              >
                {qty} {qty === 1 ? " " + t("taquilla") : " " + t("taquillas")}
              </button>
            </div>

            <vr class="bg-vw-light"></vr>

            {/* DATES */}
            <div style={{ flex: 1 }}>
              <label className="uf-label">{t("Inicio")}</label>
              <button
                type="button"
                className="uf-btn"
                onClick={() => this.openPanel("dates")}
                disabled={!selectedLockerType}
              >
                {startDate
                  ? `${startDate.toLocaleDateString()}`
                  : t("DD/MM/YYYY")}
              </button>
            </div>

            <div style={{ flex: 1 }}>
              <label className="uf-label">{t("Fin")}</label>
              <button
                type="button"
                className="uf-btn"
                onClick={() => this.openPanel("dates")}
                disabled={!selectedLockerType}
              >
                {endDate
                  ? `${endDate.toLocaleDateString()}`
                  : t("DD/MM/YYYY")}
              </button>
            </div>

            {/*DISCOUNT*/}
            {appliedRule && (
              <span style={{
                border: "1px solid #00000040",
                padding: "10px",
                borderRadius: "10px",
                maxWidth: "200px",
                maxHeight: "4vw",
                marginTop: "0.5rem"
              }}>
                {t("Descuento aplicado: {{discount}}% (desde los {{days}} días)", {
                  discount: appliedRule.DiscountPercentage,
                  days: appliedRule.MaxDays
                })}
              </span>
            )}

            {/* CONTINUE BUTTON */}
            <button
              className={`lockerContinueButtonBaqueira ${!canContinue || this.state.isLoading ? "disabled-baqueira" : ""
                }`}
              style={{ margin: "0", marginTop: "0.5rem" }}
              disabled={!canContinue || this.state.isLoading}
              onClick={() => this.handleContinue()}
            >
              {this.state.isLoading ? (
                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
              ) : (
                <>{t("Continuar")}{t(" por ")}{totalAmount.toFixed(2)}{' €'}</>
              )}
            </button>
          </div>
        </div>

        {/* ERROR MESSAGE */}
        {this.state.errorMessage &&
          <div className="text-danger text-center">{t("LO SENTIMOS PERO ESTAS FECHAS NO ESTÁN DISPONIBLES, PRUEBA OTRAS U OTRO TIPO DE TAQUILLAS.")}</div>
        }

        {/* INLINE PANELS */}
        {this.renderUnifiedPanels()}
      </>
    );
  }

  renderUnifiedPanels(mode) {
    const { t } = this.props;
    const { isTypeModalOpen, isQtyModalOpen, isDatesModalOpen, selectedQuantity, startDate, endDate, isDurationExceeded, activePanel, appliedRule } = this.state;
    const qty = selectedQuantity == null ? 1 : Number(selectedQuantity);

    return (
      <>
        {activePanel === "type" && (
          <div className="uf-panel text-center">
            <h5 className="text-vw-dark-baqueira">{t('Selecciona el tipo de taquilla')}</h5>
            {this.renderLockersPc()}
          </div>
        )}

        {activePanel === "qty" && (
          <div className="uf-panel text-center">
            <h5 className="text-vw-dark-baqueira">{t('Selecciona la cantidad')}</h5>
            <QuantityStepper
              min={1}
              max={10}
              value={qty}
              label={''}
              onChange={(v) => this.setState({ selectedQuantity: v, startDate: null, endDate: null, selectedPrices: [], totalAmount: 0, isDurationExceeded: false, appliedRule: null  })}
            />
          </div>
        )}

        {activePanel === "dates" && (
          <div className="uf-panel text-center">
            <h5 className="text-vw-dark-baqueira">{t('Selecciona las fechas')}</h5>
            {isDurationExceeded && (
              <div className="text-center text-danger mt-2">
                {t(`El alquiler online está limitado a 14 días consecutivos, para realizar reservas de larga duración diríjase al staff de Baqueira Store o solicítelo via email a skiservice@baqueira.es`)}
              </div>
            )}
            {this.renderPriceCalendarPC()}
          </div>
        )}
      </>
    );
  }

  renderStepContent() {
    const { t } = this.props;
    const { step, lockers, selectedLockerType, selectedQuantity, startDate, endDate, isDurationExceeded, useUnifiedUI } = this.state;

    const isCutoffPassed = this.isAfterCutoffTime();

    if (useUnifiedUI) {
      // Single big form for mobile
      return this.renderUnifiedForm('mobile');
    }

    const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
      <div className="d-flex justify-content-center align-items-center dates-baqueira">
        <input
          className="dates-baqueira"
          onClick={onClick}
          value={value}
          readOnly // Ensures the input is not editable, preventing the keyboard from appearing
          ref={ref}
          placeholder="DD/MM/YYYY"
        />
        <i className="fas fa-calendar ml-2"></i>
      </div>
    ));

    switch (step) {
      case 1:
        // Step 1: Select Locker Type
        return (
          <div className="lockerSelectionStep">
            {this.renderLockers()}
          </div>
        );

      case 2:
        // Step 2: Select Quantity
        return (
          <div className="quantitySelectionStep">
            <div className="d-flex justify-content-center align-items-center">
              <select className="quantity-baqueira text-center" value={selectedQuantity} onChange={this.handleQuantityChange}>
                <option key={null} value={null}>{t('Selecciona...')}</option>
                {Array.from({ length: 10 }, (_, i) => i + 1).map((num) => (
                  <option key={num} value={num}>{num} {num > 1 ? t('Taquillas') : t('Taquilla')}</option>
                ))}
              </select>
            </div>
            <br></br>
            <div className='d-flex justify-content-around align-content-center'>
              <button className="lockerBackButtonBaqueira" onClick={() => this.handleBack(1)}>
                {t("Atrás")}
              </button>
              <button disabled={!selectedQuantity || selectedQuantity === null} className={`lockerContinueButtonBaqueira ${(!selectedQuantity || selectedQuantity === null) && 'disabled-baqueira'}`} onClick={() => this.handleForward(1)}>
                {t("Continuar")}
              </button>
            </div>
          </div>
        );

      case 3:
        // Step 3: Select Dates
        return (
          <div className="dateSelectionStep">
            {isCutoffPassed && (
              <div className="text-center text-danger mb-3">
                <i className="fas fa-clock mr-2"></i>
                {t("El día actual no está disponible para selección después de las 18:00 hora local.")}
              </div>
            )}
            {isDurationExceeded && (
              <div className="text-center text-danger mb-3">
                <i className="fas fa-exclamation-triangle mr-2"></i>
                {t(
                  `El alquiler online está limitado a 14 días consecutivos, para realizar reservas de larga duración diríjase al staff de Baqueira Store o solicítelo via email a skiservice@baqueira.es`
                )}
              </div>
            )}
            <div className="">
              {/* <div className="col text-center">
                <label className="d-block">{t("Fecha de Inicio")}</label>
                <DatePicker
                  selected={startDate}
                  onChange={this.handleStartDateChange}
                  dateFormat="yyyy-MM-dd"
                  minDate={isCutoffPassed ? new Date().setDate(new Date().getDate() + 1) : new Date()}
                  locale="en-GB"
                  customInput={<CustomInput />}
                  placeholderText="DD/MM/YYYY"
                />
              </div>
              <div className="col text-center mt-3">
                <label className="d-block">{t("Fecha de Fin")}</label>
                <DatePicker
                  selected={endDate}
                  onChange={this.handleEndDateChange}
                  dateFormat="yyyy-MM-dd"
                  minDate={startDate}
                  disabled={!startDate}
                  locale="en-GB"
                  customInput={<CustomInput />}
                  placeholderText="DD/MM/YYYY"
                />
              </div> */}
              <div className="col text-center">
                {this.renderPriceCalendar()}
              </div>
            </div>
            <br></br>
            <div className='d-flex justify-content-around align-content-center'>
              <button className="lockerBackButtonBaqueira" onClick={() => this.handleBack(2)}>
                {t("Atrás")}
              </button>
              <button disabled={!startDate || isDurationExceeded} className={`lockerContinueButtonBaqueira ${(!startDate || isDurationExceeded) ? 'disabled-baqueira' : ''}`} onClick={() => this.handleForward(2)}>
                {t("Continuar")}
              </button>
            </div>
          </div>
        );

      case 4:
        // Step 4: Show Continue Button
        return (
          <div className='text-center'>
            {this.state.errorMessage &&
              <span className="text-danger">{t("LO SENTIMOS PERO ESTAS FECHAS NO ESTÁN DISPONIBLES, PRUEBA OTRAS U OTRO TIPO DE TAQUILLAS.")}</span>
            }
            <div className='d-flex justify-content-around align-content-center'>
              <button className="lockerBackButtonBaqueira" onClick={() => this.handleBack(3)}>
                {t("Atrás")}
              </button>
              <button className="lockerContinueButtonBaqueira" onClick={() => this.handleContinue()} disabled={this.state.errorMessage || this.state.isLoading}>
                {this.state.isLoading ? (
                  <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                ) : t("Confirmar")}
              </button>
            </div>
          </div>
        );

      default:
        return null;
    }
  }

  renderStepContentPc() {
    const { t } = this.props;
    const { step, lockers, selectedLockerType, selectedQuantity, startDate, endDate, isDurationExceeded, useUnifiedUI } = this.state;

    const isCutoffPassed = this.isAfterCutoffTime();


    if (useUnifiedUI) {
      // Single big form for pc
      return this.renderUnifiedFormPc();
    }

    const qty = selectedQuantity == null ? 1 : Number(selectedQuantity);

    switch (step) {
      case 1:
        // Step 1: Select Locker Type
        return (
          <div className="lockerSelectionStep">
            {this.renderLockersPc()}
          </div>
        );

      case 2:
        // Step 2: Select Quantity
        return (
          <div className="quantitySelectionStep">
            {/* <div className="d-flex justify-content-center align-items-center">
              <select className="quantity-baqueira text-center" value={selectedQuantity} onChange={this.handleQuantityChange}>
                <option key={null} value={null}>{t('Selecciona...')}</option>
                {Array.from({ length: 10 }, (_, i) => i + 1).map((num) => (
                  <option key={num} value={num}>{num} {num > 1 ? t('Taquillas') : t('Taquilla')}</option>
                ))}
              </select>
            </div> */}
            <div className="d-flex flex-column" style={{ gap: '16px' }}>
              {/* Stepper –/+ */}
              <QuantityStepper
                min={1}
                max={10}
                value={qty}
                label={t('Cantidad')}
                onChange={(v) => this.setState({ selectedQuantity: v, startDate: null, endDate: null, selectedPrices: [], totalAmount: 0, isDurationExceeded: false, appliedRule: null  })}
              />
            </div>
            <br></br>
            <div className='d-flex justify-content-around align-content-center'>
              <button className="lockerBackButtonBaqueira" onClick={() => this.handleBack(1)}>
                {t("Atrás")}
              </button>
              <button disabled={!selectedQuantity || selectedQuantity === null} className={`lockerContinueButtonBaqueira ${(!selectedQuantity || selectedQuantity === null) && 'disabled-baqueira'}`} onClick={() => this.handleForward(1)}>
                {t("Continuar")}
              </button>
            </div>
          </div>
        );

      case 3:
        // Step 3: Select Dates
        return (
          <div className="dateSelectionStep">
            {isCutoffPassed && (
              <div className="text-center text-danger mb-3">
                <i className="fas fa-clock mr-2"></i>
                {t("El día actual no está disponible para selección después de las 18:00 hora local.")}
              </div>
            )}
            {isDurationExceeded && (
              <div className="text-center text-danger mb-3">
                <i className="fas fa-exclamation-triangle mr-2"></i>
                {t(
                  `El alquiler online está limitado a 14 días consecutivos, para realizar reservas de larga duración diríjase al staff de Baqueira Store o solicítelo via email a skiservice@baqueira.es`
                )}
              </div>
            )}
            <div className="row">
              {/* <div className="col text-center mt-3">
                <div className="col text-center">
                  <label className="d-block">{t("Fecha de Inicio")}</label>
                  <DatePicker
                    selected={startDate}
                    onChange={this.handleStartDateChange}
                    dateFormat="yyyy-MM-dd"
                    minDate={isCutoffPassed ? new Date().setDate(new Date().getDate() + 1) : new Date()}
                    locale="en-GB"
                    customInput={<CustomInput />}
                    placeholderText="DD/MM/YYYY"
                  />
                </div>
                <div className="col text-center mt-3">
                  <label className="d-block">{t("Fecha de Fin")}</label>
                  <DatePicker
                    selected={endDate}
                    onChange={this.handleEndDateChange}
                    dateFormat="yyyy-MM-dd"
                    minDate={startDate}
                    disabled={!startDate}
                    locale="en-GB"
                    customInput={<CustomInput />}
                    placeholderText="DD/MM/YYYY"
                  />
                </div>
              </div> */}
              <div className="col text-center">
                {this.renderPriceCalendarPC()}
              </div>
            </div>
            <div className='d-flex justify-content-around align-content-center'>
              <button className="lockerBackButtonBaqueira" onClick={() => this.handleBack(2)}>
                {t("Atrás")}
              </button>
              <button disabled={!startDate || isDurationExceeded} className={`lockerContinueButtonBaqueira ${(!startDate || isDurationExceeded) ? 'disabled-baqueira' : ''}`} onClick={() => this.handleForward(2)}>
                {t("Continuar")}
              </button>
            </div>
          </div>
        );

      case 4:
        // Step 4: Show Continue Button
        return (
          <div className='text-center'>
            {this.state.errorMessage &&
              <span className="text-danger">{t("LO SENTIMOS PERO ESTAS FECHAS NO ESTÁN DISPONIBLES, PRUEBA OTRAS U OTRO TIPO DE TAQUILLAS.")}</span>
            }
            <div className='d-flex justify-content-around align-content-center'>
              <button className="lockerBackButtonBaqueira" onClick={() => this.handleBack(3)}>
                {t("Atrás")}
              </button>
              <button className="lockerContinueButtonBaqueira" onClick={() => this.handleContinue()} disabled={this.state.errorMessage || this.state.isLoading}>
                {this.state.isLoading ? (
                  <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
                ) : t("Confirmar")}
              </button>
            </div>
          </div>
        );

      default:
        return null;
    }
  }

  renderSelectedInfo() {
    const { selectedInfo, selectedQuantity, startDate, endDate, step, selectedLockerType } = this.state;
    const { zoneSelected, descriptionZone } = this.props.location.state;
    const { t } = this.props;

    return (
      <div>
        <p className="lockTitleBaqueira">
          <span className="text-vw-light-baqueira">{t("ZONA")}: </span>
          <span className="text-vw-dark-baqueira">{zoneSelected} - {descriptionZone}</span>
        </p>
        {step >= 2 &&
          <p className="lockTitleBaqueira">
            <span className="text-vw-light-baqueira">{t("TIPO")}: </span>
            <span className="text-vw-dark-baqueira">{this.getLockerType(selectedLockerType)}</span>
          </p>
        }
        {step >= 3 &&
          <p className="lockTitleBaqueira">
            <span className="text-vw-light-baqueira">{t("CANTIDAD")}: </span>
            <span className="text-vw-dark-baqueira">{selectedQuantity}</span>
          </p>
        }
        {step >= 3 && startDate &&
          <>
            <p className="lockTitleBaqueira">
              <span className="text-vw-light-baqueira">{t("FECHAS")}: </span>
              <span className="text-vw-dark-baqueira">
                {startDate ? startDate.toLocaleDateString() : ""} - {endDate ? endDate.toLocaleDateString() : ""}
              </span>
            </p>
            <p className="lockTitleBaqueira">
              <span className="text-vw-light-baqueira">{t("IMPORTE")}: </span>
              <span className="text-vw-dark-baqueira">{this.state.totalAmount.toFixed(2)} €</span>
            </p>
          </>
        }
      </div>
    );
  }

  render() {
    const { t } = this.props;

    return (
      <div>
        <AppBaqueiraHeader />
        <div className="lockerContainer smartphone">
          <br></br>
          <StepBarBaqueira step={2} />
          <hr className="bg-vw-light"></hr>
          <h3 className="lockTitle text-center">
            <span className="text-vw-dark-baqueira">
              {t('Reserva tu taquilla')}
            </span>
          </h3>
          {/*
          <h6 className="lockTitle text-center">
            <span className="text-vw-semidark-baqueira">
              {t('Rellena los datos para ver disponibilidad')}
            </span>
          </h6>
          <br></br>
          */}
          {this.renderStepContent()}
        </div>

        <div className="lockerContainer pc">
          <br></br>
          <StepBarBaqueira step={2} />
          <hr className="bg-vw-light"></hr>
          <h3 className="text-left">
            <span className="text-vw-dark-baqueira">
              {t('Reserva tu taquilla')}
            </span>
          </h3>
          {/*
          <h6 className="text-left">
            <span className="text-vw-semidark-baqueira">
              {t('Rellena los datos para ver disponibilidad')}
            </span>
          </h6>
          */}
          <br></br>
          {this.renderStepContentPc()}
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  auth: true,
  lockers: state.lockers,
  prices: state.prices
})

const mapDispatchToProps = dispatch => ({
  push: bindActionCreators(push, dispatch),
  fetchDisponibility: bindActionCreators(fetchDisponibility, dispatch),
  fetchAvailability: bindActionCreators(fetchAvailability, dispatch),
  fetchCalendarByOperator: bindActionCreators(fetchCalendarByOperator, dispatch),
})

export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(LockerSelectorBaqueiraView));
